module.exports = __webpack_public_path__ + "gu.svg?4605ab0276a72f771320afe88eb4bd52";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/gu.svg
// module id = 1018
// module chunks = 27